/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 22/03/2024
 */

import auth from '../../../middleware/auth.js';
import shortcuts from '../../../middleware/shortcuts.js';
import {appHelper} from "../../../utils/helpers/appHelper.js";
import {elementHelper} from "../../../utils/helpers/elementHelper.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";
export const AdminRegions = [
    {
        path: appHelper.path.adminApp + '/region',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth, shortcuts] },
        children: [
            {
                path: 'currency',
                name: 'adminAppCurrency',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/currency/index.vue'))
            },
            {
                path: 'country',
                name: 'adminAppCountry',
                component: routeHelper.asyncComponentWithLoader(()=> import('../../region/views/country/index.vue'))
            },
            {
                path: 'state',
                name: 'adminAppState',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/state/index.vue'))
            },
            {
                path: 'city',
                name: 'adminAppCity',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/city/index.vue'))
            },
            {
                path: 'regional',
                name: 'adminAppRegional',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/regional/index.vue'))
            },
            {
                path: 'sub-regional',
                name: 'adminAppSubRegional',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/sub-regional/index.vue'))
            }
        ]
    }
];
